import CRUDService from "./CRUDService";

class CommentService extends CRUDService {
  constructor() {
    super('comments')
  }
}

export default new CommentService()
